module.exports = __webpack_public_path__ + "media/images/talent/lp/profile02-5cdbb06708bb1aa68be2f2cb731a3294.png";